const STORAGE_KEY = 'easc-theme';

type Theme = 'light' | 'dark';

function getStoredTheme(): Theme | null {
  const value = localStorage.getItem(STORAGE_KEY);
  return value === 'light' || value === 'dark' ? value : null;
}

function getCurrentTheme(): Theme {
  return (document.documentElement.getAttribute('data-theme') as Theme) || 'light';
}

function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', theme);
  localStorage.setItem(STORAGE_KEY, theme);
  window.dispatchEvent(new CustomEvent<Theme>('themechange', { detail: theme }));

  const labels = document.querySelectorAll<HTMLElement>('[data-theme-toggle-label]');
  const buttons = document.querySelectorAll<HTMLButtonElement>('[data-theme-toggle]');
  const next = theme === 'dark' ? 'light' : 'dark';
  labels.forEach((label) => {
    label.textContent = next === 'dark' ? 'Dark' : 'Light';
  });
  buttons.forEach((button) => {
    button.setAttribute('aria-pressed', String(theme === 'dark'));
    button.setAttribute('aria-label', `Switch to ${next} theme`);
  });
}

export function initThemeToggle(): void {
  applyTheme(getCurrentTheme());

  const buttons = document.querySelectorAll<HTMLButtonElement>('[data-theme-toggle]');
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const next: Theme = getCurrentTheme() === 'dark' ? 'light' : 'dark';
      applyTheme(next);
    });
  });

  if (!getStoredTheme()) {
    window
      .matchMedia('(prefers-color-scheme: dark)')
      .addEventListener('change', (event) => applyTheme(event.matches ? 'dark' : 'light'));
  }
}
